import { Component, OnInit, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import {
  NgbDateParserFormatter,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";

import { isNullOrUndefined } from 'src/app/services/utils';
import {
  COMMON_CONSTANTS,
  ENTITLEMENT_ACTIVITYNAMES,
  MANAGE_LINE_CONST,
  MANAGE_MODAL_CONST,
  SUSPEND_CONSTANTS,
  VALUE,
  ANALYTICS,
} from "../../../common/core/common.constants";
import {
  BulkRequestsForRestore,
  RequestsBulkLine,
  RequestsForRestore
} from "../../../common/models/data.model";
import { SuccessComponent } from "../success/success.component";

import { ManageLineService } from "src/app/services/manage-line.service";
import { DateFormatService } from "src/app/services/date-format.service";
import { HttpCacheService } from "src/app/services/http-cache.service";
import { UtilsService } from "src/app/services/utils.service";
import { environment } from "src/environments/environment";
import { PDLService } from "src/app/services/pdl-service.service";

@Component({
  selector: "app-restore",
  templateUrl: "./restore.component.html",
  styleUrls: ["./restore.component.scss"],
  providers: [{ provide: NgbDateParserFormatter, useClass: DateFormatService }],
})
export class RestoreComponent implements OnInit {
  ngbModalOptions: NgbModalOptions;
  selectedLines: any;
  restoreLines: any = [];
  restoreDate: any;
  restoreDateGlobal: any;
  isDate: boolean;
  selectsubmitCheckBox: any;
  @ViewChild("ngxdp") ngxdp;
  @ViewChild("dp") datePicker;
  restoredLines: any;
  restoreHeader: string;
  restoreDateHdr: any;
  restoreDatepnl: any;
  succesValidator = true;
  errorValidator = false;
  msgShowOnPanel = false;
  authInfo: any;
  authoringContentData: any;
  currentDate: any;
  currentPstDate: any;
  minimumDate: any;
  maximumDate: any;
  one: number;
  restoreInfoTxt: any;
  showErrorMessage: string;
  checkboxDisable = true;
  tncCheckboxDisable = true;
  dateForamted: any;
  counter: number;
  restoreDateGlobalCheckbox = false;
  orgId: any;
  isSingleLine: boolean = false;
  btnDisabled = true;
  isLineDetailsWindow: boolean;
  isEndUser = this.utilsSvc.IsEndUser();
  approvalFlags: any;
  isApprovalRequired: any;
  isSubmitReadOnly: boolean;
  singleLineReasonCode: any;
  isAmOktaEnabled: boolean;
  constructor(
    public manageLineService: ManageLineService,
    private utilsSvc: UtilsService,
    private modalService: NgbModal,
    private datePipe: DatePipe,
    private _cacheSvc: HttpCacheService,
    private pdlService: PDLService
  ) {
    this.isLineDetailsWindow = false;
  }

  ngOnInit() {
    this.one = COMMON_CONSTANTS.DIGITS.ONE;
    this.counter = COMMON_CONSTANTS.DIGITS.ZERO;
    this.succesValidator = true;
    this.restoreDateGlobalCheckbox = false;
    this.restoreDate = "";
    this.dateForamted = "";
    this.restoreDateGlobal = "";
    this.restoreDateHdr = "";
    this.restoreDatepnl = "";
    this.restoreDatepnl = "";
    this.restoreLines = [];
    this.authInfo = JSON.parse(
      this._cacheSvc.getFromSessionStorage(
        MANAGE_LINE_CONST.AUTHENTICATION_INFO
      )
    );
    this.isAmOktaEnabled = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) !== COMMON_CONSTANTS.IAM_KEY;
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.currentDate = new Date();
    this.currentPstDate = new Date(this.currentDate.toLocaleString(COMMON_CONSTANTS.EN_US, {timeZone: COMMON_CONSTANTS.LA_TIMEZONE}));
    this.orgId = !isNullOrUndefined(
      this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORG_ID_KEY)
    )
      ? this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORG_ID_KEY)
      : "";
    this.minimumDate = {
      year: this.currentPstDate.getFullYear(),
      month: this.currentPstDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
      day: this.currentPstDate.getDate(),
    };
    this.restoreDate = this.minimumDate;

    if (
      !isNullOrUndefined(this.selectedLines) &&
      this.selectedLines.length > COMMON_CONSTANTS.DIGITS.ZERO
    ) {
      for (const line of this.selectedLines) {
        if (
          !isNullOrUndefined(line) &&
          !isNullOrUndefined(line.statusCode) &&
          line.statusCode === MANAGE_LINE_CONST.SUSPENDED
        ) {
          this.restoreLines.push(line);
        }
      }
      if (
        !isNullOrUndefined(this.restoreLines) &&
        this.restoreLines.length !== COMMON_CONSTANTS.DIGITS.ZERO
      ) {
        if (this.restoreLines.length === 1) {
          this.isSingleLine = true;
        } else {
          this.isSingleLine = false;
        }
        this.restoreLines[0].expendFlagValue = true;
        this.restoreLines.forEach((element) => {
          if (
            !isNullOrUndefined(element) &&
            !isNullOrUndefined(element.msisdn)
          ) {
            element.multiRestoreDate = this.minimumDate;
            this.getSubscriberStatus(element);
          }
        });
      }
    }
    this.isSubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(
      ENTITLEMENT_ACTIVITYNAMES.RESTORE_SINGLE
    );

    if (this.isSingleLine) {
      this.pdlService.ifEnabledGenerateModalViewTag({
        eventAction: ANALYTICS.LOAD,
        modalName: this.authoringContentData.manageLineRestore.singleLineHeader,
      });
    }
  }

  getSubscriberStatus(line): void {
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.msisdn)) {
      this.manageLineService.getSubscriberStatus(line.msisdn).subscribe(
        (subscriberStatusRes) => {
          if (
            !isNullOrUndefined(subscriberStatusRes) &&
            !isNullOrUndefined(subscriberStatusRes.statusReasonCode) &&
            !isNullOrUndefined(subscriberStatusRes.code) &&
            subscriberStatusRes.code === MANAGE_LINE_CONST.SUCCESS
          ) {
            line.reasonCode = subscriberStatusRes.statusReasonCode;
            this.singleLineReasonCode = subscriberStatusRes.statusReasonCode;
            if (
              !isNullOrUndefined(line) &&
              isNullOrUndefined(line.restoreDate)
            ) {
              const restoreDate = this.returnDateFormat(this.currentPstDate);
              line.restoreDate = restoreDate;
            }
            if (
              !isNullOrUndefined(
                this.authoringContentData &&
                  this.authoringContentData.manageLineRestore &&
                  this.authoringContentData.manageLineRestore.restoreInfoTxt &&
                  subscriberStatusRes &&
                  subscriberStatusRes.statusDate &&
                  this.datePipe
              )
            ) {
              line.restoreInfoTxt =
                this.authoringContentData.manageLineRestore.restoreInfoTxt.replace(
                  MANAGE_LINE_CONST.SUSPEND_DATE,
                  this.datePipe.transform(
                    subscriberStatusRes.statusDate,
                    MANAGE_MODAL_CONST.DATE_FORMAT_MM_DD_YYYY
                  )
                );
            }
            line.showErrorMessage = "";
            this.getSuspendedApprovalTypes(line);
          } else {
            line.showErrorMessage = !isNullOrUndefined(
              this.authoringContentData &&
                this.authoringContentData.manageLineRestore &&
                this.authoringContentData.manageLineRestore.serverErrorTxt
            )
              ? this.authoringContentData.manageLineRestore.serverErrorTxt
              : "";
          }
        },
        (subscriberError) => {
          this.callsOnError(line);
        }
      );
    }
  }

  getSuspendedApprovalTypes(line) {
    this.manageLineService.suspendApprovalTypes(line.reasonCode).subscribe(
      (approvalTypeResponse) => {
        if (approvalTypeResponse?.status === MANAGE_LINE_CONST.SUCCESS) {
          if (approvalTypeResponse.approverTypes?.length > 0) {
            line.approverTypeList = approvalTypeResponse.approverTypes;
            switch (line.reasonCode) {
              case MANAGE_LINE_CONST.TMPS:
                line.approverType = SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_VP_AND_QA_TEAM;
                break;
              case MANAGE_LINE_CONST.RSQ:
                line.approverType = SUSPEND_CONSTANTS.APPROVER_TYPES.VP;
                break;
              case MANAGE_LINE_CONST.RSS:
                line.approverType = SUSPEND_CONSTANTS.APPROVER_TYPES.VP;
                break;
              case MANAGE_LINE_CONST.SSQ:
                line.approverType = SUSPEND_CONSTANTS.APPROVER_TYPES.VP;
                break;
              case MANAGE_LINE_CONST.IMS:
                line.approverType = SUSPEND_CONSTANTS.APPROVER_TYPES.VP;
                break;
              default:
                line.approverType = '';
                break;
            }
            this.getRestorationEligibility(line);
          } else {
            line.approverTypeList = '';
            line.approverType = '';
            this.getRestorationEligibility(line);
          }
        } else {
          line.showErrorMessage = this.authoringContentData?.manageLineRestore?.serverErrorTxt || '';
        }
      },
      (approvalTypeError) => {
        this.callsOnError(line);
      }
    );
  }

  callsOnError(line){
    line.showErrorMessage = !isNullOrUndefined(
      this.authoringContentData &&
        this.authoringContentData.manageLineRestore &&
        this.authoringContentData.manageLineRestore.serverErrorTxt
    )
      ? this.authoringContentData.manageLineRestore.serverErrorTxt
      : "";
  }

  getEndDaysFromReasonCode(reasonCode) {
    if (!isNullOrUndefined(reasonCode)) {
      if (
        reasonCode === SUSPEND_CONSTANTS.TEMP_SUSPEND ||
        reasonCode === SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES ||
        reasonCode === SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES ||
        reasonCode === SUSPEND_CONSTANTS.RETENTION_SUSPEND ||
        reasonCode === SUSPEND_CONSTANTS.SUNC_SUSPEND
      ) {
        return COMMON_CONSTANTS.DIGITS.ZERO;
      } else if (reasonCode === SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND || reasonCode ===
SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND) {
        return COMMON_CONSTANTS.DIGITS.THIRTY;
      } else if (reasonCode === SUSPEND_CONSTANTS.SEASONAL_SUSPEND) {
        return COMMON_CONSTANTS.DIGITS.NINTY;
      } else if (reasonCode === SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND) {
        return COMMON_CONSTANTS.DIGITS.SIXTY;
      } else if (reasonCode === SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND) {
        return COMMON_CONSTANTS.DIGITS.NINTY;
      } else {
        return COMMON_CONSTANTS.DIGITS.ZERO;
      }
    } else {
      return COMMON_CONSTANTS.DIGITS.ZERO;
    }
  }

  isRestoreDateToday(restoreDate, todayDate) {
    if (this.datePipe.transform(restoreDate, 'MMM. d, y') === this.datePipe.transform(todayDate, 'MMM. d, y')) {
      return true;
    } else {
      return false;
    }
  }

  getRestorationEligibility(line): void {
    const todayDate = this.currentPstDate;
    if (
      !isNullOrUndefined(line) &&
      !isNullOrUndefined(line.msisdn) &&
      !isNullOrUndefined(line.reasonCode) &&
      !isNullOrUndefined(line.restoreDate)
    ) {
      // checking for restore date equals to current Date
      let request:any = {};
      request.mobileNumber = line.msisdn;
      request.reasonCode = line.reasonCode;
      request.restoreDate = line.restoreDate;
      request.validatorType = line.approverType;

      if (this.isRestoreDateToday(line.restoreDate, todayDate)) {
        this.manageLineService
          .getRestorationEligibility(request)
          .subscribe(
            (eligibilityRes) => {
              this.counter++;
              this.btnDisabled = false;
              if (
                !isNullOrUndefined(eligibilityRes) &&
                !isNullOrUndefined(eligibilityRes.status) &&
                eligibilityRes.status === MANAGE_LINE_CONST.SUCCESS
              ) {
                const date1 = eligibilityRes.suspendStartDate.split("-");
                const suspendedDate = new Date(
                  date1[VALUE.ZERO] +
                    "," +
                    date1[VALUE.ONE] +
                    "," +
                    date1[VALUE.TWO]
                );

                const endDays = this.getEndDaysFromReasonCode(
                  eligibilityRes.reasonCode
                );
                let dateToSet_EndDate: any;
                if (
                  eligibilityRes.reasonCode ===
                    SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES ||
                  eligibilityRes.reasonCode ===
                    SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES ||
                  eligibilityRes.reasonCode === SUSPEND_CONSTANTS.TEMP_SUSPEND
                ) {
                  dateToSet_EndDate = this.currentPstDate;
                } else {
                  dateToSet_EndDate = new Date(
                    suspendedDate.setDate(suspendedDate.getDate() + Number(endDays))
                  );
                }
                if (dateToSet_EndDate < this.currentPstDate) {
                  dateToSet_EndDate = this.currentPstDate;
                }
                this.maximumDate = {
                  year: dateToSet_EndDate.getFullYear(),
                  month:
                    dateToSet_EndDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
                  day: dateToSet_EndDate.getDate(),
                };
                line.maximumDate = this.maximumDate;
                line.tncCheckboxDisable = false;
                line.ban = !isNullOrUndefined(eligibilityRes.ban)
                  ? eligibilityRes.ban
                  : "";
                line.dealerCode = !isNullOrUndefined(eligibilityRes.dealerCode)
                  ? eligibilityRes.dealerCode
                  : "";
                line.showErrorMessage = "";
                line.succesValidator = true;
                line.errorValidator = false;
                this.multiplRestoreDateSelected(line);
                line.msgShowOnPanel = true;
                this.restoreLines[0].msgShowOnPanel = false;
              } else {
                line.tncCheckboxDisable = true;
                line.succesValidator = false;
                line.errorValidator = true;
                if(!isNullOrUndefined(eligibilityRes && eligibilityRes.message)){
                  line.showErrorMessage = eligibilityRes.message;
                }
                else if(!isNullOrUndefined(this.authoringContentData &&this.authoringContentData.manageLineRestore &&this.authoringContentData.manageLineRestore.serverErrorTxt)){
                  line.showErrorMessage = this.authoringContentData.manageLineRestore.serverErrorTxt;
                }
                else{
                  line.showErrorMessage = "";
                }
                let dateToSet_EndDate = this.currentPstDate;
                this.maximumDate = {
                  year: dateToSet_EndDate.getFullYear(),
                  month:
                    dateToSet_EndDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
                  day: dateToSet_EndDate.getDate(),
                };
                line.maximumDate = this.maximumDate;
              }
              if (
                !isNullOrUndefined(this.restoreLines) &&
                this.counter === this.restoreLines.length
              ) {
                this.validateTncCheckbox();
              }
            },
            (eligibilityError) => {
              this.counter++;
              if (
                !isNullOrUndefined(this.restoreLines) &&
                this.counter === this.restoreLines.length
              ) {
                this.validateTncCheckbox();
              }
              line.succesValidator = false;
              line.errorValidator = true;
              line.tncCheckboxDisable = true;
              line.showErrorMessage = !isNullOrUndefined(
                this.authoringContentData &&
                  this.authoringContentData.manageLineRestore &&
                  this.authoringContentData.manageLineRestore.serverErrorTxt
              )
                ? this.authoringContentData.manageLineRestore.serverErrorTxt
                : "";
            }
          );
      }
    }
  }

  validateTncCheckbox() {
    this.checkboxDisable = false;
    for (const element of this.restoreLines) {
      if (!isNullOrUndefined(element) && element.tncCheckboxDisable) {
        this.checkboxDisable = true;
        break;
      }
    }
  }

  multiplRestoreDateSelecttion(line) {
    this.restoreDateGlobalCheckbox = false;

    this.multiplRestoreDateSelected(line);
  }

  multiplRestoreDateSelected(line) {
    if (line?.multiRestoreDate?.year && line.multiRestoreDate.month && line.multiRestoreDate.day && this.datePipe) {

      const multiRestoreDate = new Date(
        line.multiRestoreDate.year,
        line.multiRestoreDate.month - 1,
        line.multiRestoreDate.day
      );
      const maxDate = new Date(
        line.maximumDate.year,
        line.maximumDate.month - 1,
        line.maximumDate.day
      );
      if (multiRestoreDate > maxDate) {
        line.restoreDate = this.datePipe.transform(
          new Date(
            line.maximumDate.year,
            line.maximumDate.month - 1,
            line.maximumDate.day
          ),
          MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL
        );
        line.dateForamted = new Date(
          line.maximumDate.year,
          line.maximumDate.month - 1,
          line.maximumDate.day
        );
        line.maxDateEligibleMessage = true;
      } else {
        line.restoreDate = this.datePipe.transform(
          new Date(
            line.multiRestoreDate.year,
            line.multiRestoreDate.month - 1,
            line.multiRestoreDate.day
          ),
          MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL
        );
        line.dateForamted = new Date(
          line.multiRestoreDate.year,
          line.multiRestoreDate.month - 1,
          line.multiRestoreDate.day
        );
        line.maxDateEligibleMessage = false;
      }
    }
    if (line?.restoreDate) {
      const dateFormated = line.restoreDate.split('-');
      const lineRestoreDate = new Date(dateFormated[VALUE.ONE] + '-' + dateFormated[VALUE.TWO] + '-' + dateFormated[VALUE.ZERO]);
      line.multiRestoreDate = {
        year: lineRestoreDate.getFullYear(),
        month: lineRestoreDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: lineRestoreDate.getDate(),
      };
    }
  }

  changeDate() {
    this.isDate = true;
  }

  onFocusDate() {
    this.datePicker.open();
  }

  onBlurDate() {
    this.datePicker.close();
  }

  dateSelect(evt) {
    this.isDate = false;
  }

  onApplySelectngx(evt) {
    this.ngxdp.hide();
  }

  removeNumber(line) {
    if (!isNullOrUndefined(line) && !isNullOrUndefined(this.restoreLines)) {
      const index = this.restoreLines.indexOf(line);
      this.restoreLines.splice(index, 1);
      this.manageLineService.changeCurrentSelection(line);
      this.validateTncCheckbox();
      if (this.restoreLines.length === 0) {
        this.manageLineService.close();
      }
    }
  }

  // when expansion panel is closed we are showing message
  expansionPanelClosed(line) {
    line.msgShowOnPanel = true;
    line.expendFlagValue = false;
  }
  // when expansaion panel is open we are hiding message
  expansionPanelOpened(line) {
    line.msgShowOnPanel = false;
    line.expendFlagValue = true;
  }

  nextStep(line) {
    const nextIndex = this.restoreLines.findIndex(
      (item) => item.msisdn === line.msisdn
    );
    if(this.restoreLines.length - 1 > nextIndex) {
      this.restoreLines[nextIndex + 1].expendFlagValue = true;
    }
    this.restoreLines[nextIndex].expendFlagValue = false;
  }

  // when apply all checkbox is clicked
  applyToAllCheckbox(event) {
    if (!isNullOrUndefined(event) && event.checked) {
      this.restoreForEach();
    } else {
      this.restoreLines.forEach((element) => {
        if (!isNullOrUndefined(this.minimumDate && element)) {
          element.multiRestoreDate = this.minimumDate;
          this.multiplRestoreDateSelected(element);
        }
      });
    }
  }

  applyToAllCalenders() {
    if (
      !isNullOrUndefined(this.restoreDateGlobalCheckbox) &&
      this.restoreDateGlobalCheckbox
    ) {
      this.restoreForEach();
    }
  }

  restoreForEach() {
    this.restoreLines.forEach((element) => {
      if (!isNullOrUndefined(this.restoreDateGlobal && element)) {
        element.multiRestoreDate = this.restoreDateGlobal;
        this.multiplRestoreDateSelected(element);
      }
    });
  }

  settingBodyDataForRestoreSubmit(line): RequestsForRestore {
    const restoreModel = new RequestsForRestore();
    this.authInfo = JSON.parse(
      this._cacheSvc.getFromSessionStorage(
        MANAGE_LINE_CONST.AUTHENTICATION_INFO
      )
    );
    if (line) {
      restoreModel.mobileNumber = line.msisdn || '';
      restoreModel.ban = line.ban || "";
      restoreModel.reasonCode = line.reasonCode || "";
      restoreModel.restoreDate = line.restoreDate || "";
      restoreModel.logonId = !isNullOrUndefined(this.authInfo)
        ? this.authInfo.logonID
        : COMMON_CONSTANTS.LOGON_ID;
      restoreModel.email = !isNullOrUndefined(this.authInfo)
        ? this.authInfo.logonEmail
        : COMMON_CONSTANTS.LOGON_ID;
      restoreModel.dealerCode = line.dealerCode || "";
    }
    return restoreModel;
  }

  oneLineDateSelected(line): void {
    this.counter = 0;
    if (
      !isNullOrUndefined(line) &&
      !isNullOrUndefined(line.multiRestoreDate) &&
      !isNullOrUndefined(line.multiRestoreDate.year) &&
      !isNullOrUndefined(line.multiRestoreDate.month) &&
      !isNullOrUndefined(line.multiRestoreDate.day) &&
      !isNullOrUndefined(this.datePipe)
    ) {
      line.restoreDate = this.datePipe.transform(
        new Date(
          this.restoreDate.year,
          this.restoreDate.month - 1,
          this.restoreDate.day
        ),
        MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL
      );
      if (!isNullOrUndefined(line) && !isNullOrUndefined(line.reasonCode)) {
        this.getRestorationEligibility(line);
      } else {
        this.getSubscriberStatus(line);
      }
    }
  }

  returnDateFormat(date) {
    if (
      !isNullOrUndefined(date) &&
      !isNullOrUndefined(
        date.getFullYear() && date.getMonth() && date.getDate()
      ) &&
      !isNullOrUndefined(this.datePipe)
    ) {
      return this.datePipe.transform(
        new Date(date.getFullYear(), date.getMonth(), date.getDate()),
        MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL
      );
    }
  }

  submitRestoreLine() {
    if (!isNullOrUndefined(this.restoreLines) && this.isSingleLine) {
      const restoreheaderBody = this.settingBodyDataForRestoreSubmit(
        this.restoreLines[0]
      );
      if (
        !isNullOrUndefined(this.restoreLines[0]) &&
        !isNullOrUndefined(this.restoreLines[0].msisdn) &&
        !isNullOrUndefined(restoreheaderBody)
      ) {
        this.manageLineService
          .serviceRestore(restoreheaderBody)
          .subscribe(
            (restoreLineResponse) => {
              if (
                !isNullOrUndefined(restoreLineResponse) &&
                !isNullOrUndefined(restoreLineResponse.accountTransRefNum) &&
                !isNullOrUndefined(restoreLineResponse.status) &&
                restoreLineResponse.status === MANAGE_LINE_CONST.SUCCESS
              ) {
                this.restoreLineSuccess(restoreLineResponse.accountTransRefNum);
              } else {
                this.restoreLines[0].showErrorMessage =
                  restoreLineResponse.message;
              }
            },
            (error) => {
              this.restoreLineError(error);
            }
          );
        this.pdlService.ifEnabledGenerateClickTag({
          type: ANALYTICS.CLICK_TO_ACTION,
          action: ANALYTICS.CLICK,
          ctaName:
            this.authoringContentData.manageLineRestore.submitChangeTxt,
          assetType: ANALYTICS.BUTTON,
          modalName:
            this.authoringContentData.manageLineRestore.singleLineHeader,
        });
      }
    } else {
      this.restoreBulkLines();
    }
  }

  restoreBulkLines(): void {
    const bulkRestoreRequestPayload = new BulkRequestsForRestore();
    bulkRestoreRequestPayload.targetServiceName =
      MANAGE_LINE_CONST.RESTORE_SERVICE;
      bulkRestoreRequestPayload.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.authInfo = JSON.parse(
      this._cacheSvc.getFromSessionStorage(
        MANAGE_LINE_CONST.AUTHENTICATION_INFO
      )
    );
    this.restoreLines.forEach((element) => {
      if (!isNullOrUndefined(element)) {
        const bulkJsonData = new RequestsBulkLine();
        bulkJsonData.orgId = this.orgId;
        bulkJsonData.msisdn = !isNullOrUndefined(element && element.msisdn)
          ? element.msisdn
          : "";
        bulkJsonData.reasonCode = !isNullOrUndefined(
          element && element.reasonCode
        )
          ? element.reasonCode
          : "";
        bulkJsonData.restoreDate = !isNullOrUndefined(
          element && element.restoreDate
        )
          ? element.restoreDate
          : "";
        bulkJsonData.logonId = !isNullOrUndefined(this.authInfo)
          ? this.authInfo.logonID
          : COMMON_CONSTANTS.LOGON_ID;
        bulkJsonData.email = !isNullOrUndefined(this.authInfo)
          ? this.authInfo.logonEmail
          : COMMON_CONSTANTS.LOGON_ID;
        bulkJsonData.dealerCode = !isNullOrUndefined(
          element && element.dealerCode
        )
          ? element.dealerCode
          : "";
        bulkJsonData.validatorType = !isNullOrUndefined(
          element && element.approverType
        )
          ? element.approverType
          : "";
        bulkRestoreRequestPayload.requests.push(bulkJsonData);
      }
    });
    this.manageLineService
      .bulkServiceRestore(bulkRestoreRequestPayload)
      .subscribe(
        (restoreLineResponse) => {
          if (
            !isNullOrUndefined(restoreLineResponse) &&
            !isNullOrUndefined(restoreLineResponse.token) &&
            !isNullOrUndefined(restoreLineResponse.status) &&
            restoreLineResponse.status === MANAGE_LINE_CONST.SUCCESS
          ) {
            this.restoreLineSuccess(restoreLineResponse.token);
          } else {
            this.restoreLines[0].showErrorMessage = !isNullOrUndefined(
              this.authoringContentData &&
                this.authoringContentData.manageLineRestore &&
                this.authoringContentData.manageLineRestore.serverErrorTxt
            )
              ? this.authoringContentData.manageLineRestore.serverErrorTxt
              : "";
          }
        },
        (error) => {
          this.restoreLineError(error);
        }
      );
  }

  restoreLineSuccess(accountTransRefNum): void {
    if (this.isEndUser && environment.ENABLE_AHUB_FLOW) {
      this.approvalFlags = JSON.parse(
        this._cacheSvc.getFromSessionStorage("approvalFlags")
      );
      if (!isNullOrUndefined(this.approvalFlags)) {
        this.iterateOnApprovalFlagObj(this.approvalFlags);
      }
    }
    this.ngbModalOptions = {
      container: "#am-container-custom",
    };
    if (!isNullOrUndefined(accountTransRefNum)) {
      this.manageLineService.close();
      this.restoreLines[0].showErrorMessage = "";
      const successModalRef = this.modalService.open(
        SuccessComponent,
        this.ngbModalOptions
      );
      successModalRef.componentInstance.token = accountTransRefNum;
      successModalRef.componentInstance.isLineDetailsWindow =
        this.isLineDetailsWindow;
      if (
        this.isEndUser &&
        this.isSingleLine &&
        this.isApprovalRequired === COMMON_CONSTANTS.DIGITS.ONE
      ) {
        successModalRef.componentInstance.isConfirmationPopup = true;
        successModalRef.componentInstance.isRestore = true;
        successModalRef.componentInstance.header =
          this.authoringContentData.manageLineRestore.restoreConfirmationApproval;
        successModalRef.componentInstance.processText =
          this.authoringContentData.manageLineRestore.restoreProcessText;
        successModalRef.componentInstance.modalBodyContent =
          this.authoringContentData.manageLineRestore.confirmationModalBody;
      } else {
        successModalRef.componentInstance.header = !isNullOrUndefined(
          this.authoringContentData &&
            this.authoringContentData.manageLineRestore &&
            this.authoringContentData.manageLineRestore.restoreRequestComplete
        )
          ? this.authoringContentData.manageLineRestore.restoreRequestComplete
          : "";
      }
    }
  }

  iterateOnApprovalFlagObj(approvalFlags){
    for(let flag of approvalFlags) {
      this.callsWhenFlagISRestore(flag);
     }
  }

  callsWhenFlagISRestore(flag){
    if (flag.FlagName === COMMON_CONSTANTS.IS_RESTORE_APPROVAL) {
      this.isApprovalRequired = flag.FlagValue;
    }
  }

  restoreLineError(error): void {
    this.manageLineService.close();
    this.utilsSvc.errorHandling(error);
  }

  resettingAllValues() {
    if (
      !isNullOrUndefined(this.restoreLines) &&
      this.restoreLines.length !== COMMON_CONSTANTS.DIGITS.ZERO
    ) {
      for (const line of this.restoreLines) {
        if (!isNullOrUndefined(line)) {
          line.msgShowOnPanel = false;
          line.succesValidator = false;
          line.errorValidator = false;
          line.reasonForChanges = "";
          line.approverType = "";
          line.startDate = "";
          line.endDate = "";
        }
      }
    }
  }

  closePopupTagging() {
    this.modalService.dismissAll();

    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.CLOSE,
      modalName: this.authoringContentData.manageLineRestore.singleLineHeader,
    });
  }
}
